import { hasClosest } from '../../app/helpers'

const CSS = {
  open: 'nav-open',
  current: {
    ctn: 'nav__item--current',
    link: 'f500',
  },
  prev: {
    link: 'hover-green',
  },
}

export default class {
  constructor(root) {
    this.root = root
    this.ctn = document.getElementById('menu')
    this.current = document.getElementsByClassName(CSS.current.ctn)
  }

  close() {
    this.toggle(false)
  }

  toggle(isOpen = !this.isOpen) {
    this.isOpen = isOpen

    this.root.classList.toggle(CSS.open, isOpen)
  }

  updateColor(page) {
    this.ctn.classList.toggle('header--white', page === 'service')
  }

  updateCurrentNavItem(page) {

    // Old nav item.
    Array.from(this.current).forEach(prevItem => {
      prevItem.classList.remove(CSS.current.ctn)

      const prevLink = prevItem.querySelector('a')
      if (prevLink) {
        prevLink.classList.remove(CSS.current.link)
        prevLink.classList.add(CSS.prev.link)
      }
    })

    // New nav item.
    const parent = document.querySelector(`.nav-${page}`)

    if (parent) {
      let theLink = parent.querySelector('a')
      parent.classList.add(CSS.current.ctn)
      theLink.classList.remove(CSS.prev.link)
      theLink.classList.add(CSS.current.link)
    }
  }

  onPageChange(page) {
    this.close()
    this.updateColor(page)
    this.updateCurrentNavItem(page)
  }

  onTap(e) {
    if (hasClosest(e.target, '#nav-open, #nav-close')) {
      e.preventDefault()
      this.toggle()
    }
  }

  onResize(closeServiceMenu = false) {
    if (closeServiceMenu) {
      this.close()
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/modules/Menu/index.js